"use client";

import { useTranslations } from "next-intl";

const ROW_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export interface OvermoldingVsInsertMoldingTableProps {
	translationNamespace?: string;
}

/**
 * Overmolding vs. Insert Molding：居中标题与引言，三列表格（绿表头、灰边框），小屏横向滚动
 */
export default function OvermoldingVsInsertMoldingTable({
	translationNamespace = "overmoldingVsInsertMoldingSection",
}: OvermoldingVsInsertMoldingTableProps) {
	const t = useTranslations(translationNamespace);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
				<h2 className="mb-3 text-center text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
					{t("title")}
				</h2>
				<p className="mb-6 text-center text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base lg:mb-12">
					{t("intro")}
				</p>

				<div className="overflow-x-auto border border-gray-200 shadow-sm">
					<table className="w-full min-w-[640px] border-collapse text-left text-sm sm:min-w-[680px] sm:text-base">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th
									scope="col"
									className="border border-white/30 px-4 py-4 font-bold sm:px-5 sm:py-5 lg:w-[20%]"
								>
									{t("colAspect")}
								</th>
								<th scope="col" className="border border-white/30 px-4 py-4 font-bold sm:px-5 sm:py-5">
									{t("colOvermolding")}
								</th>
								<th scope="col" className="border border-white/30 px-4 py-4 font-bold sm:px-5 sm:py-5">
									{t("colInsert")}
								</th>
							</tr>
						</thead>
						<tbody>
							{ROW_NUMBERS.map((n) => (
								<tr key={n} className="bg-white">
									<td className="border border-gray-200 px-4 py-4 font-bold text-black sm:px-5 sm:py-5">
										{t(`row${n}Aspect`)}
									</td>
									<td className="border border-gray-200 px-4 py-4 font-normal leading-relaxed text-black sm:px-5 sm:py-5">
										{t(`row${n}Overmolding`)}
									</td>
									<td className="border border-gray-200 px-4 py-4 font-normal leading-relaxed text-black sm:px-5 sm:py-5">
										{t(`row${n}Insert`)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
